<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoTasa()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listTipoTasa.length > 0">
            <div class="col-md-7">
                <b-table
                    :items="listTipoTasa"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editTipoTasa(item.id)"
                >
                    <template #cell(tipo_tasa)="data">
                        <div class="text-right">{{ data.item.tipo_tasa }}</div>
                    </template>
                    <template #cell(frecuencia)="data">
                        <div class="text-right">{{ data.item.frecuencia }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="listTipoTasa.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            v-model="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <!-- <md-table md-card md-header md-fixed-header v-model="listTipoTasa">
                <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editTipoTasa(item.id)">
                    <md-table-cell :md-label="labels.codigo" class="border">{{ item.tipo_tasa }}</md-table-cell>
                    <md-table-cell :md-label="labels.descripcion" class="border text-left">{{ item.descripcion }}</md-table-cell>
                    <md-table-cell :md-label="labels.frecuencia" class="border text-left">{{ item.frecuencia }}</md-table-cell>
                    <md-table-cell :md-label="labels.modalidad" class="border text-left">{{ item.modalidad }}</md-table-cell>
                </md-table-row>
            </md-table> -->
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showTipoTasa" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoTasa" :infoTipoTasa="dataTipoTasa" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoTasas from '../../../services/TipoTasas';
import Crear from './Crear';
import Editar from './Editar';

export default {
    name: 'TipoTasas',
    components:{Crear,Editar},
    data:() => ({
        listTipoTasa : [],
        showTipoTasa : false,
        showEditTipoTasa : false,
        dataTipoTasa : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_tasa', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'frecuencia', label: 'Frecuencia', sortable: false },
            { key: 'modalidad', label: 'Modalidad', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Tipo tasas',
                    codigo : "Código",
                    descripcion : "Descripción",
                    frecuencia : "Frecuencia",
                    modalidad : "Modalidad",
                    noRow : "No hay registros"
                }
            }else{
                return {
                    title : 'Rate type',
                    codigo : "Code",
                    descripcion : "Description",
                    frecuencia : "Frecuency",
                    modalidad : "Type",
                    noRow : "There are not records"
                }
            }
        }
    },
    methods:{
        createTipoTasa(){
            this.showTipoTasa = true
        },
        editTipoTasa(id){
            // console.log(id);
            TipoTasas.getTipoTasaById(id)
            .then((res) => {
                this.dataTipoTasa = res.data.tipoTasa
                this.showEditTipoTasa = true
            })
            .catch((err) => { console.log(err) })
        },
        closeModal(valor){
            this.showTipoTasa = valor
            this.showEditTipoTasa = valor
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data.listTipoTasas);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => { console.log(err) })
    }
}
</script>

<style>

</style>
